<template>

  <ion-row>
    <ion-col>
      <h2>Featured Clients & Deliverables</h2>
    </ion-col>
  </ion-row>
  <ion-row>

    <ion-col v-for="(client, index) in clients" :key="index">
      <JobExperiences
      :client="client.name"
      :project="client.project"
      />
    </ion-col>

   </ion-row>

</template>
<script>

import { IonRow, IonCol } from '@ionic/vue';
import JobExperiences from './JobExperiences.vue';

export default {
  name: 'Experiences',
  components: {
    IonRow, IonCol, JobExperiences
  },
  data() {
    return {
      clients: [
        {
          name: "Shipt",
          project: {
            name: 'Customer Segmentation',
            deliverable: 'An Apache-Airflow batch job to generate the inferred customer segmentation cluster number',
            description: 'This is a model based on a clustering algorithm to provide insights into the type of customers Shipt has based on their shopping history'
          }
        },
        {
          name: "Levi Strauss & Co.",
          project: {
            name: 'Product Recommendations',
            deliverable: "A REST API, deployed into a Kubernetes cluster, that is able to produce a set of recommendations for a customer on Levi's website",
            description: "Through the use of the customer journey and product-level embeddings, a tensorflow deep learning model is trained and deployed to create the liklihood a product would be acted on"
          }
        },
        {
          name: "BNL Consulting",
          project: {
            name: "Regex SAS Script Parser",
            deliverable: "A python application to parse information about a SAS script",
            description: "This is a python application designed to parse different pieces of information about a SAS script (i.e. number of proc SQL statements, data statements, etc)"
          }
        },
        {
          name: "Nielsen",
          project: {
            name: "Total Media Fusion Project",
            deliverable: "A series of Apache-Airflow & Apache-Spark batch jobs that will perform Data Integration using the Total Media Fusion Methodology to create one true media source",
            description: "This project was originally developed on-premise and in SAS. Edward's focus was to transform this manual, unscalable process into an automated, scalable, cloud-centric solution. Edward also focused on improving QA of the solutions, and to improve overall computational performance."
          }
        }
      ]
    }
  }
}
</script>
